import WidgetSideBarContainer from './container'

export default WidgetSideBarContainer
